// extracted by mini-css-extract-plugin
export default {"bottomNav":"BottomNav_bottomNav__2qp6Z","item":"BottomNav_item__NqOE2","active":"BottomNav_active__F+AWS","label":"BottomNav_label__NomwI","hidden":"BottomNav_hidden__S0zzJ"};